<div class="EditContentGroup">
  <div class="EditContentGroup-body d-flex flex-column">
    <div class="EditContentGroup-body-header flex-grow-1 d-flex flex-row">
      <div class="EditContentGroup-body-header-title flex-grow-1">
        <h4>Update Content Group Name for {{ contentGroupName }}</h4>
      </div>
      <div class="EditContentGroup-body-header-back flex-grow-0">
        <a [routerLink]="['/contents/content_group']">Back to contents</a>
      </div>
    </div>
    <div class="EditContentGroup-body-form flex-grow-1">
      <form [formGroup]="inputForm">
        <mat-form-field>
          <mat-label>New content group name</mat-label>
          <input
            matInput
            [placeholder]="'Enter new content group name'"
            formControlName="groupName"
            [value]="contentGroupName" />
        </mat-form-field>
        <div *ngIf="groupEditError" class="alert alert-danger">
          <p>Group with this name already exists</p>
        </div>
      </form>
    </div>
    <div
      class="EditContentGroup-body-footer flex-grow-1 d-flex align-items-end">
      <app-button
        *ngIf="cancelButtonProperties"
        class="EditContentGroup-body-footer-button"
        [text]="cancelButtonProperties.text"
        [size]="cancelButtonProperties.size"
        [color]="cancelButtonProperties.color"
        [route]="cancelButtonProperties.route"></app-button>
      <app-button
        class="EditContentGroup-body-footer-button"
        [text]="submitButtonProperties.text"
        [size]="submitButtonProperties.size"
        [color]="submitButtonProperties.color"
        [Click]="submitButtonProperties.onClick"></app-button>
    </div>
  </div>
</div>
